import React from "react";
import "./TagpayListComponent.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import Table from "react-bootstrap/Table";
import eyeTag from "../../../../assests/eyeTag.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import rechargeIcon from "../../../../assests/rechargeIcon.svg";
import addIcon from "../../../../assests/addicon.svg";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";

const TagpayListComponent = (props) => {
  const { seriesId } = useParams();
  const navigate = useNavigate();

  const handleHomeClick = () => navigate("/");
  const handleBackClick = () => navigate(-1);

  const managePartnerDetails = (seriesId) => {
    navigate(`/home/walletandtag/tagpymanagementdetails/${seriesId}`);
  };

  return (
    <div className="tagpay-management-container">
      <Sidebar />
      
      <div className="tagpay-management-content">
        {props.loading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div className="tagpay-management-header">
              <button onClick={handleBackClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Tagpay Management</h1>
            </div>

            <div className="tagpay-management-controls">
            <div className="tagpay-search-container">
    <div className="tagpay-searchbar">
      <input
        type="search"
        className="tagpay-searchbar-input"
        placeholder="Search by Cop. ID / Corporate name"
        value={props.searchValue}
        onChange={props.handleSearchInputChange}
      />
      <button
        className="tagpay-searchbar-button"
        onClick={props.handleFilterFranchisees}
        aria-label="Search"
      >
        <img src={search} alt="Search" />
      </button>
   
    </div>
  </div>

              <Button
                variant="contained"
                className="add-button"
                onClick={props.handleAddNewTags}
              >
                + Add New
              </Button>
            </div>

            <div className="tagpay-table-container">
              <div className="table-scroll-wrapper" ref={props.tableContainerRef}>
                <Table className="tagpay-table">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Corp. ID</th>
                      <th>Corporate Name</th>
                      <th>Series ID</th>
                      <th>Initial Balance</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredTagSeriesList?.length > 0 ? (
                      props.filteredTagSeriesList.map((item, index) => (
                        <React.Fragment key={item.index}>
                          {item.corporate_series.map((series, id) => (
                            <tr key={id} className="tagpay-view">
                              <td>{index + 1}</td>
                              <td>{item.corporate_id}</td>
                              <td>{item.corporate_name}</td>
                              <td>{series.id}</td>
                              <td>{series.initial_balance}</td>
                              <td >
                                <img 
                                  src={eyeTag} 
                                  alt="View" 
                                  className="tagpay-eye-icon"
                                />
                                <img
                                  src={addIcon}
                                  alt="Add"
                                  className="tagpay-eye-icon"
                                />
                                <img
                                  src={rechargeIcon}
                                  alt="Recharge"
                                  onClick={(e) => managePartnerDetails(series.id)}
                                  className="tagpay-eye-icon"
                                />
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="no-results">
                          <div className="no-results-content">
                            <img src={emotions7} alt="No results" />
                            <p>No Tagpay Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TagpayListComponent;